'use client';

// Simply re-export Button component "as-is" but add "use client" annotation to indicate
// that the component does not support RSC as it uses context and state under the hood
import { Button } from '@rescui/button';

export default Button;
